import type { Ref } from 'vue'
import { ref } from 'vue'

import type {
    ActiveReportDetail,
    ReportDictionaryItem,
    ReportPrintVariant,
    ShipmentReportDetail
} from '@/api/schemas/reports/common'
import type { CreateReportPayloadSchema, ReportAdditionalAction, ReportTaskDetails } from '@/api/schemas/reports/reportExecution'
import type { OperatorReportingCreateContext } from '@/stores/reportsV2/reportExecution/types'

export type ReportDetailOrigin =
    | 'operator-reporting'
    | 'manager-approvals'
    | 'my-reports'
    | 'reporting-and-analysis'
    | 'dashboard'
    | null

export type ReportExecutionState = {
    activeReportId: Ref<number | null>
    activeReport: Ref<ActiveReportDetail | null>
    activeShipmentReport: Ref<ShipmentReportDetail | null>
    detailOrigin: Ref<ReportDetailOrigin>
    printVariant: Ref<ReportPrintVariant>
    reportDraft: Ref<CreateReportPayloadSchema | null>
    operatorReportingCreateContext: Ref<OperatorReportingCreateContext | null>
    prefetchedCreateTask: Ref<ReportTaskDetails | null>
    commentCodes: Ref<ReportDictionaryItem[]>
    additionalActions: Ref<ReportAdditionalAction[]>
}

export function createReportExecutionState(): ReportExecutionState {
    return {
        activeReportId: ref<number | null>(null),
        activeReport: ref<ActiveReportDetail | null>(null),
        activeShipmentReport: ref<ShipmentReportDetail | null>(null),
        detailOrigin: ref<ReportDetailOrigin>(null),
        printVariant: ref<ReportPrintVariant>(null),
        reportDraft: ref<CreateReportPayloadSchema | null>(null),
        operatorReportingCreateContext: ref<OperatorReportingCreateContext | null>(null),
        prefetchedCreateTask: ref<ReportTaskDetails | null>(null),
        commentCodes: ref<ReportDictionaryItem[]>([]),
        additionalActions: ref<ReportAdditionalAction[]>([])
    }
}
